<script>
export default {
  name: "UniversalTabs",
  props: ["initalTab"],
  data() {
    return {
      activeTab: this.initalTab,
    };
  },
  methods: {
    switchTabTo(tab) {
      this.activeTab = tab;
    },
    isTabActive(tab) {
      return this.activeTab == tab;
    },
  },
};
</script>

<template>
  <div class="univarsal-tabs">
    <div class="tabs">
      <slot name="tabs" :switchTabTo="switchTabTo" :isTabActive="isTabActive" />
    </div>
    <slot :name="'tab-' + activeTab" />
  </div>
</template>
